// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"b80eff2c","4229":"b80eff2c","7950":"b80eff2c","8906":"b80eff2c"}[chunkId] + ".chunk.css";
};